import { FlowEntry, FlowProgressWithSteps, FlowRoute } from 'utils/FlowProvider/types'

export const NavSteps: (entry: FlowEntry, props: any) => FlowProgressWithSteps = (
  entry,
  { visitedPages, history },
) => {
  if (!entry) {
    history.push(FlowRoute.Welcome, { pageNotFound: true })
  }

  const visitedSpendConfirmation = visitedPages.includes(FlowRoute.SpendOrderConfirmation)

  const billingAddress = entry.page === FlowRoute.ContactInfo
  const signYourCard = entry.page === FlowRoute.SignYourCard

  if (visitedSpendConfirmation && (billingAddress || signYourCard)) {
    entry.progress = {
      stepOverallProgress: 60,
    }
  }
  return { ...entry.progress, steps: [] }
}
